module.exports = __webpack_public_path__ + "img/Transpordiamet_vapp_varviline_eng.3f509f57.svg";